export default __webpack_public_path__ + "static/style3.5_Roman-9d62c135fa0c6110355e04a435c1e790.wav";